import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const PageAnchorWrapper = styled('div')`
  position: relative;
`;

type AnchorType = 'section-title' | 'sub-section-title';

export interface AnchorProps {
  type?: AnchorType;
}

export const Anchor = styled('div')<AnchorProps>`
  position: absolute;

  top: ${({ theme, type }) =>
    `calc((${
      type === 'sub-section-title' ? theme.x18spacePx : theme.x15spacePx
    }px + ${theme.safeAreaInsetTop})*-1)`};
  ${media.lgUp`
		top: ${({ theme, type }) =>
      `calc((${
        type === 'sub-section-title' ? theme.x12spacePx : theme.x8spacePx
      }px + ${theme.safeAreaInsetTop})*-1)`};
	`};
`;
